import { render, staticRenderFns } from "./CSATStarInput.vue?vue&type=template&id=53f667b9&scoped=true&"
import script from "./CSATStarInput.vue?vue&type=script&lang=js&"
export * from "./CSATStarInput.vue?vue&type=script&lang=js&"
import style0 from "./CSATStarInput.vue?vue&type=style&index=0&id=53f667b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f667b9",
  null
  
)

export default component.exports